export default __webpack_public_path__ + "static/media/bp-summer.a77d4d37.gif";